export default "__VITE_ASSET__bfab75e2__"